import { LucideGrid } from "lucide-react";
import React from "react";

import { Stack, Heading } from "@/components/ui";

/**
 * MatrixHeader - Header component for Matrix screen
 *
 * @returns {JSX.Element} Die gerenderte MatrixHeader-Komponente
 *
 */
export const MatrixHeader: React.FC = () => {
  return (
    <Stack align="center" direction="row" justify="between">
      <Stack direction="col" gap={1}>
        <Heading className="text-xl font-semibold text-white" level={2}>
          Priority Matrix
        </Heading>
        <p className="text-slate-300">Impact vs Effort Matrix for prioritization</p>
      </Stack>
      <Stack align="center" className="text-slate-300" direction="row" gap={2}>
        <LucideGrid className="w-4 h-4" />
        <span className="text-sm">Matrix View</span>
      </Stack>
    </Stack>
  );
};
